"use client"

import React, { useState } from "react"
import { LinkedinShareButton, LinkedinIcon } from "react-share"

import { fullURLfromURI } from "@/helpers/utils"

interface ShareProps {
  title: string
  description: string
  uri: string
  round?: boolean
  borderRadius?: number
  iconFillColor?: string
  bgStyle?: object
  iconFillColorHover?: string
  bgStyleHover?: object
}

const LinkedInShare: React.FC<ShareProps> = ({
  title,
  description,
  uri,
  round = true,
  borderRadius,
  iconFillColor = "#d6d9db",
  bgStyle = { fill: "#141a1f" },
  iconFillColorHover = "#2e3439",
  bgStyleHover = { fill: "#aeb3b7" },
}) => {
  const [isHover, setIsHover] = useState(false)

  const handleMouseEnter = () => {
    setIsHover(true)
  }

  const handleMouseLeave = () => {
    setIsHover(false)
  }

  if (!title || !description || !uri) {
    return null
  }
  return (
    <LinkedinShareButton
      className="mx-3"
      title={title}
      summary={description}
      url={fullURLfromURI(uri)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <LinkedinIcon
        size={48}
        round={round}
        borderRadius={borderRadius}
        iconFillColor={isHover ? iconFillColorHover : iconFillColor}
        bgStyle={isHover ? bgStyleHover : bgStyle}
      />
    </LinkedinShareButton>
  )
}

export default LinkedInShare
